(function ($) {
	'use strict'

	// ===============================================================================
	// AJAX - FILTRES
	// ===============================================================================

	// SOUMISSION DES FILTRES
	// *******************************************************************************
	$('body').on('submit', '.js-filters-form', function (e) {
		e.preventDefault()
		var $this = $(this)

		$this.next('.js-ajax-content').addClass('is-loading') // on ajoute une classe au contenu pour bloquer le clic

		$this.find('.js-filters-tags').hide().find('.tag').remove() // on enlève les tags des filtres sélectionnés et on le masque

		var postType = $this.attr('data-type') // le post type à passer sur le formulaire en data

		var template = $this.attr('data-template') // le template à passer sur le formulaire en data

		var display = $this.attr('data-display') // condition d'affichage (pour afficher la pagi / filtre au rechargement ajax)

		var tagName = $this.attr('data-tag-name') // balise html du titre

		var paged = $this.attr('data-paged') // le numéro de page à passer sur le formulaire en data par le click sur un lien de pagination

		var switchValue = $this.attr('data-switch') // évènements passés ou futurs à afficher dans le bloc évènement au click (cpt_event)

		var valuesFilter = {
			'action': 'filters', // le nom de l'action dans le function.php
			'postType': postType,
			'template': template,
			'display': display,
			'tagName': tagName,
			'switch': switchValue,
			'paged': paged
		}

		$this.find('.js-filter-field').each(function () { // pour chaque filtre
			var name = $(this).attr('name').replace('[]', '') // on récupère le name sans les [] (tableau)

			if ($(this).val() != '') { // si le filtre n'est pas vide
				if ($(this).is(':radio') || $(this).is(':checkbox')) { // si c'est un radio OU un checkbox
					if ($(this).is(':checked')) { // si c'est celui sélectionné
						if ($.isArray(valuesFilter[name])) {
							valuesFilter[name].push($(this).val()) // on récupère les valeurs sélectionnées dans une variable pour la passer au data de l'ajax
						} else {
							valuesFilter[name] = [$(this).val()] // on récupère les valeurs sélectionnées dans une variable pour la passer au data de l'ajax
						}
					}
				} else {
					valuesFilter[name] = $(this).val() // on récupère les valeurs sélectionnées dans une variable pour la passer au data de l'ajax
				}

				name = $(this).attr('name').replace(/\[(.*)\]/, '') // on vire tout ce qu'il y a dans les crochets
				if (!$(this).hasClass('js-filter-no-tag')) { // si il n'a pas la classe js-filter-no-tag
					addFilterTag($('#' + name)) // on crée le tag pour chaque valeur sélectionnée
				}
			} else { // si le filtre est vide
				name = $(this).attr('name').replace(/\[(.*)\]/, '') // on vire tout ce qu'il y a dans les crochets
				valuesFilter[name] = '' // on envoi vide
			}
		})

		// si il y a des filtres, on affiche les filtres
		if ($this.find('.js-filters-tags').find('.tag').length) {
			$this.find('.js-filters-tags').show()
		}

		jQuery.post(
			ajaxurl,
			valuesFilter,
			function (response) {
				$this.next('.js-ajax-content').html(response).removeClass('is-loading') // on ajoute le contenu retourné par l'action dans le function.php

				$this.attr('data-paged', 1) // on remet la pagination à 1

				// $('html, body').animate({scrollTop:$('.js-ajax-content').position().top}, 'slow') // on revient en haut de page
			}
		)
	})

	// SOUMISSION FORMULAIRE
	// *******************************************************************************
	$('.js-submit-filter .wp-block-button__link').on('click', function (e) {
		e.preventDefault()

		$(this).parents('.js-filters-form').submit() // on soumet le formulaire en ajax
	})

	// REINITIALISATION FORMULAIRE
	// *******************************************************************************
	$('.js-reset-filter .wp-block-button__link').on('click', function (e) {
		e.preventDefault()

		$(this).parents('.js-filters-form').find('.js-filter-field').each(function(){
			if( $(this).is(':checkbox') ) {
				// on décoche les checkbox
				$(this).prop('checked', false)
				$(this).parent('label').removeClass('checked')
			} else {
				// on vide tous les champs
				$(this).val('')

				// on remet à 0 les select
				$(this).parents('.selectric-wrapper').next('.filter-label').text($(this).parents('.selectric-wrapper').next('.filter-label').text().replace(/\((.*)\)/, ''))
			}
		})

		// on soumet le formulaire en ajax
		$(this).parents('.js-filters-form').submit()
	})

	// PAGINATION
	// *******************************************************************************
	// au changement de page
	$('.js-ajax-content').on('click', '.js-paging .page-numbers', function (e) {
		var url = $(this).attr('href') // url de la page
		var paged = url.split('?paged=') // récupération du numéro de page

		if (paged[1]) {
			paged = paged[1]
		} else {
			paged = url.split("/")
			paged = paged[paged.length - 2]
		}

		e.preventDefault() // on arrête l'action de base

		$(this).parents('.js-ajax-content').prev('.js-filters-form').attr('data-paged', paged) // on remplace le numéro de page

		$(this).parents('.js-ajax-content').prev('.js-filters-form').submit() // on soumet le formulaire en ajax
	})

	// CAS : CHAMP AVEC TAG
	// *******************************************************************************
	// au load
	$('.js-filter-field').each(function () { // pour chaque filtre
		if ($(this).val() !== '' && !$(this).hasClass('js-filter-no-tag')) { // si le filtres n'est pas vide ET n'a pas la classe js-filter-no-tag
			var name = $(this).attr('name').replace(/\[(.*)\]/, '') // on récupère le name sans les [] (tableau)
			addFilterTag($('#' + name)) // on crée le tag pour chaque valeur sélectionnée
		}
	})

	// à la suppression d'un tag
	$('body').on('click', '.js-filters-tags-remove', function () {
		const fieldId = $(this).attr('data-name') // nom du champ
		const optionValue = $(this).attr('data-id') // value de l'option
		const formName = $(this).parents('.js-filters-form')

		if (optionValue) {
			formName.find('#' + fieldId).find('option[value="' + optionValue + '"]').prop('selected', false) // on déselectionne l'option du champ
			formName.find('#' + fieldId).selectric()
			if (typeof formName.find('#' + fieldId).attr('multiple') !== 'undefined' && formName.find('#' + fieldId).attr('multiple') !== false) {
				numberItemsSelected(formName.find('#' + fieldId)) // on met à jour le nombre d'éléments sélectionnés dans le champ
			}
		}

		conditionalFilter(formName.find('#'+fieldId))

		formName.submit() // on soumet le formulaire en ajax
	})

	// CAS : LISTE DÉROULANTE MULTIPLE
	// *******************************************************************************
	// au load
	$('.js-filter-field[multiple]').each(function () {
		numberItemsSelected($(this))
	})

	// au changement de valeur
	$('body').on('change', '.js-filter-field[multiple]', function () {
		numberItemsSelected($(this))
	})

	// CAS : CHAMPS SANS RECHARGEMENT AVEC LE BOUTON SUBMIT GÉNÉRAL
	// *******************************************************************************
	// Liste déroulante multiple, on soumet que quand on ferme
	$('.js-filter-on-change.filter-select-multiple').on('selectric-close', function () {
		$(this).parents('.js-filters-form').submit() // on soumet le formulaire en ajax
	})
	// Autres cas
	$('.js-filter-on-change:not(.filter-select-multiple)').on('change', function () {
		$(this).parents('.js-filters-form').submit() // on soumet le formulaire en ajax
	})

	// CAS : CHAMPS TEXTE SOUMETTRE LE FORM TOUCHE ENTREE
	// *******************************************************************************
	$('.js-filter-field[type="text"]').on('keypress', function(e){
		if (e.keyCode == 13) {
			e.preventDefault()
			$(this).parents('.js-filters-form').submit() // on soumet le formulaire en ajax
		}
	})

	// CAS : CHAMPS CONDITIONNELS
	// *******************************************************************************
	if( $('.js-filter-field').length && $('.js-filter-conditional').length ) {
		$('.js-filter-field').each(function() { // au chargement
			conditionalFilter($(this))
		})

		$('.js-filter-field').on('change', function() { // au change de chaque filtre
			conditionalFilter($(this))
		})
	}

	// OUVERTURE / FERMETURE FILTRES
	// *******************************************************************************
	$('.js-open-filter .wp-block-button__link').on('click', function (e) {
		e.preventDefault()

		if ($(this).hasClass('is-open')) {
			$(this).removeClass('is-open')
			$(this).parents('.js-filters-form').find('.js-filter').slideUp()
		} else {
			$(this).addClass('is-open')
			$(this).parents('.js-filters-form').find('.js-filter').slideDown()
		}
	})

	// AUTOCOMPLETE
	// *******************************************************************************
	// quand on saisie dans le champ
	$('.js-filter-field-autocomplete').on('keydown', function (e) {
		// si la valeur est supérieur à 2 caractères

		if ($(this).val().length > 0) {

			// on affiche seulement les valeurs correspondant à la recherche
			var value = $(this).val().toLowerCase().trim()
			$(this).next('.js-filter-field-autocomplete-list').find('.js-filter-field-autocomplete-item').show().filter(function () {
				return $(this).text().toLowerCase().trim().indexOf(value) == -1
			}).hide()

			$(this).next('.js-filter-field-autocomplete-list').removeClass('hide') // on affiche la liste

			if (e.keyCode === 40) { // si on se déplace vers le bas
				e.preventDefault()
				$(this).next('.js-filter-field-autocomplete-list').find('.js-filter-field-autocomplete-item:visible:first').get(0).focus() // on focus la première
			}
		} else { // sinon on cache la liste
			$(this).next('.js-filter-field-autocomplete-list').addClass('hide')
		}

		if (e.keyCode === 13) { // si on valide le champ en cliquant sur entrée
			e.preventDefault()
			$(this).next('.js-filter-field-autocomplete-list').addClass('hide') // on masque la liste
			$(this).parents('.js-filters-form').submit() // on soumet le formulaire en ajax
			return false
		}
	})

	// Quand on bouge avec le clavier dans la liste
	$('.js-filter-field-autocomplete-list').on('keydown', function (e) {
		var focusLi = document.activeElement // get focused item

		if (e.keyCode === 13) { // si on clique sur entrée sur une élément de la liste
			e.preventDefault()

			if (focusLi) {
				$(this).find('.js-filter-field-autocomplete-item').removeClass('is-checked') // on déselectionne tous
				$(focusLi).addClass('is-checked') // on sélectionne cet élément
				$(this).prev('.js-filter-field-autocomplete').val($(focusLi).text().trim()) // on rempli le champ avec cette valeur
				$(this).addClass('hide') // on masque la liste
			}
		} else if (e.keyCode === 40) { // si on se déplace vers le bas dans la liste
			e.stopPropagation()
			e.preventDefault()
			$(focusLi).next($('.js-filter-field-autocomplete-item:visible')).get(0).focus() // on focus la li visible d'après
		} else if (e.keyCode === 38) { // si on se déplace vers le haut dans la liste
			e.stopPropagation()
			e.preventDefault()
			$(focusLi).prev($('.js-filter-field-autocomplete-item:visible')).get(0).focus() // on focus la li visible d'avant
		}
	})

	// quand on choisi une valeur dans la liste
	$('.js-filter-field-autocomplete-item').on('click', function () {
		$('.js-filter-field-autocomplete-item').removeClass('is-checked') // on déselectionne tous
		$(this).addClass('is-checked') // on sélectionne cet élément
		$(this).parent('.js-filter-field-autocomplete-list').prev('.js-filter-field-autocomplete').val($(this).text().trim()) // on rempli le champ avec cette valeur
		$(this).parent('.js-filter-field-autocomplete-list').addClass('hide') // on masque la liste
	})

	// quand on clique en dehors du champ
	window.addEventListener('click', function (e) {
		if (e.target != $('.js-filter-field-autocomplete')) {
			$('.js-filter-field-autocomplete-list').addClass('hide') // on masque la liste
		}
	})

	// ===============================================================================
	// FONCTIONS UTILES
	// ===============================================================================

	// Affiche le nombre d'éléments sélectionnés dans la liste déroulante pour les filtres
	// *******************************************************************************
	function numberItemsSelected(elt) {
		var count = elt.find('option:selected').length // nombre d'éléments sélectionnés
		var label = elt.parents('.selectric-wrapper').next('.filter-label') // label
		var result = label.text().match(/\((.*)\)/) // cherche si les parenthèses existent

		if (result == null) { // si elles n'existent pas
			if (count != 0) {
				label.append(' (' + count + ')') // on ajoute le nombre d'éléments sélectionnés dans des parenthèses
			}
		} else { // sinon
			if (count == 0) { // si le nombre d'éléments sélectionnés est de 0
				var replace = label.text().replace(/\((.*)\)/, '') // on supprime le nombre d'éléments sélectionnés et les parenthèses
			} else { // sinon
				var replace = label.text().replace(/\((.*)\)/, '(' + count + ')') // on récupère le nombre d'éléments sélectionnés avec les parenthèses
			}

			label.html(replace) // et on remplace totalement le label
		}
	}

	// Ajoute le HTML du filtre en tag pour chaque option sélectionnée
	// *******************************************************************************
	function addFilterTag(field) {
		field.find('option:selected').each(function () {
			$('.js-filters-tags').append('<span class="tag">' + $(this).text() + '<button type="button" class="icon-remove js-filters-tags-remove" data-name="' + field.attr('id') + '" data-id="' + $(this).val() + '"></button></span>')
		})
	}

  // Gère l'affichage et la valeurs des filtres conditionnels
  // *******************************************************************************
  function conditionalFilter(field) {
    var name = field.attr('name').replace('[]', '') // on récupère le name sans les [] (tableau)
    var value = field.val()

    $('.js-filter-conditional').each(function(){
			// si y'a un filtre qui doit s'afficher en fonction de ce champ
			if( $(this).attr('data-conditional-name') === name ){
				// si c'est une checkbox ET que c'est la bonne valeur
				// OU que ce n'est pas une checkbox
				if(
					(field.is(':checkbox') && $(this).attr('data-conditional-value') === value)
					|| !field.is(':checkbox')
				){
					// si c'est une checkbox ET qu'elle est checked
					// OU si ce n'est pas une checkbox ET que c'est la bonne valeur
					// OU si ce n'est pas une checkbox ET que la valeur est un array ET que la valeur est dans l'array
					if(
						( field.is(':checkbox') && field.is(':checked') )
						|| ( !field.is(':checkbox') && $(this).attr('data-conditional-value') === value )
						|| ( !field.is(':checkbox') && $.isArray(value) && $.inArray($(this).attr('data-conditional-value'), value) !== -1 )
					) {
						// on affiche le champ
						$(this).show()
					} else {
						// on masque le champ ET on le vide
						$(this).hide()
						$(this).find('.js-filter-field').val('').selectric('refresh')
						numberItemsSelected($(this).find('.js-filter-field'))
					}
				}
      }
    })
  }

	// BLOCK EVENEMENTS : GESTION PASSE / FUTURE
	// *******************************************************************************
	// au changement de page
	$('.js-ajax-content').on('click', '.js-switch', function (e) {
		e.preventDefault() // on arrête l'action de base

		var switchValue = $(this).attr('data-switch')

		$(this).parents('.js-ajax-content').prev('.js-filters-form').attr('data-switch', switchValue)

		$(this).parents('.js-ajax-content').prev('.js-filters-form').submit() // on soumet le formulaire en ajax
	})

})(jQuery)
